define('modules/accounts/companies/collection',['require','exports','module','app','env','base/collection'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");
    var BaseCollection = require("base/collection");

    var Collection = BaseCollection.extend({
        initialize: function() {
            this.initRequestEvents();
        },
        url: function() {
            return Config.backendUrl + "/accounts/companies";
        },
        parse: function(response, options) {
            var companies = response._embedded.companies;
            return companies;
        }
    });

    module.exports = Collection;
});

